import React, { useState } from 'react';
import { connect } from 'redux-zero/react';
import { holderActions } from 'app/state/actions';
import { DsIcon, DsTab, DsTabs } from '@tokenyico/design-system/dist/reactJS';
import { Redirect } from 'react-router-dom';
import { TableView } from 'app/components';
import BillboardView from './BillboardView';
import CentralizedExchangesView from './CentralizedExchangesView/CentralizedExchangesView';

import './styles.less';

const BuySell = ({
  holder: {
    selectedToken: { tradable, cexTradable },
  },
}) => {
  const [currentTab, setCurrentTab] = useState(0);

  if (tradable && !cexTradable) {
    return (
      <TableView>
        <div className="buy-sell__tabs">
          <DsTabs version="border">
            <DsTab activeClassName="active-tab">
              <DsIcon name="transfer" />
              <span>Billboard</span>
            </DsTab>
          </DsTabs>
        </div>
        <BillboardView />
      </TableView>
    );
  }

  if (!tradable && cexTradable) {
    return (
      <TableView>
        <div className="buy-sell__tabs">
          <DsTabs version="border">
            <DsTab activeClassName="active-tab">
              <DsIcon name="trend" /> <span>Centralized Exchange</span>
            </DsTab>
          </DsTabs>
        </div>
        <CentralizedExchangesView />
      </TableView>
    );
  }

  if (tradable && cexTradable) {
    return (
      <TableView style={currentTab === 1 ? { height: 'auto' } : {}}>
        <div className="buy-sell__tabs">
          <DsTabs
            onTabChange={({ detail }) => setCurrentTab(detail)}
            currentTab={currentTab}
            version="border"
          >
            <DsTab activeClassName="active-tab">
              <DsIcon name="transfer" />
              <span>Billboard</span>
            </DsTab>

            <DsTab activeClassName="active-tab">
              <DsIcon name="trend" /> <span>Centralized Exchange</span>
            </DsTab>
          </DsTabs>
        </div>
        {currentTab === 0 ? <BillboardView /> : <CentralizedExchangesView />}
      </TableView>
    );
  }

  return (
    <>
      <Redirect from="/billboard" to="/dashboard" />
    </>
  );
};

const mapToProps = (state) => state;

export default connect(mapToProps, holderActions)(BuySell);
